import { createContext, useContext, useMemo } from 'react'

export type AppMode = 'admin' | 'agent' | 'master'

function detectMode(): AppMode {
  const { hostname, search } = window.location
  if (hostname.startsWith('master.')) return 'master'
  if (hostname.startsWith('agent.')) return 'agent'
  if (hostname.startsWith('admin.')) return 'admin'
  // dev: ?mode=agent|master overrides default
  const q = new URLSearchParams(search).get('mode')
  if (q === 'master') return 'master'
  if (q === 'agent') return 'agent'
  return 'admin'
}

const AppModeContext = createContext<AppMode>('admin')

export function AppModeProvider({ children }: { children: React.ReactNode }) {
  const mode = useMemo(detectMode, [])
  return <AppModeContext.Provider value={mode}>{children}</AppModeContext.Provider>
}

export function useAppMode(): AppMode {
  return useContext(AppModeContext)
}
